export const style = {
    endAdornmentContainer: {
        backgroundColor: "transparent",
        color: "greyscale.800",
        border: "none",
        padding: 0.5,
        "&:hover, &:active": {
            backgroundColor: "transparent",
            border: "none"
        }
    },
    iconButton: {
        width: 20,
        height: 20
    },
    infoIcon: {
        height: 16,
        width: 16,
        fill: "transparent",
        "& path": {
            stroke: theme => theme.palette.greyscale[600]
        },
        marginTop: 0.5
    },
    searchListIcon: {
        width: 150,
        height: 140
    },
    schemaName: { fontSize: "14px", color: "greyscale.900", fontWeight: 400, fontFamily: "Inter" }
};
